import { Element } from "@easy-email-pro-core/typings";
import React, { useContext } from "react";

export interface ParentElementContextProps {
  element: Element | null;
}

const ParentElementContext = React.createContext<ParentElementContextProps>(
  {} as any
);

export const useParentElementContext = () => {
  return useContext(ParentElementContext);
};

export const ParentElementProvider: React.FC<
  ParentElementContextProps & { children: React.ReactNode }
> = (props) => {
  return (
    <ParentElementContext.Provider value={props}>
      {props.children}
    </ParentElementContext.Provider>
  );
};
